/**
 * Free-month promo popup config.
 * Discount is applied when the user enters this code on Stripe Checkout.
 */
export const FREE_MONTH_PROMO = {
	PROMO_CODE: 'SIMPLIFIED',
	TITLE: 'Get Your First Month Free',
	BODY: 'Use promo code SIMPLIFIED at checkout to get your first month free.',
	CHECKOUT_HINT: 'Enter this code on the checkout page.',
	CTA_LABEL: 'Check out plans',
	COPY_LABEL: 'Copy Code',
	COPIED_LABEL: 'Copied!',
	STORAGE_KEY: 'violerts_free_month_promo_tracking',
	ANONYMOUS_KEY: 'anonymous',
	SHOW_DELAY_MS: 2000,
	ONE_DAY_MS: 24 * 60 * 60 * 1000,
	DISMISS_COOLDOWN_MS: 3 * 24 * 60 * 60 * 1000,
	PRICING_PATH: '/pricing',
};
